import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  DestroyRef,
  Injector,
  OnInit,
  afterNextRender,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ElegibilidadeBeneficios } from '../../../../core/models/parametros/beneficios.model';
import { BeneficiosService } from '../../../../core/services/parametros/beneficios.service';
import { ToastService } from '../../../../core/services/toast.service';
import { descreverRegras } from '../../../../core/utils/parametros/beneficios.defaults';
import { LoaderService } from '../../../../shared/services/loader/loader.service';

interface LinhaMatriz {
  id: number;
  nome: string;
  ativo: boolean;
  condicoes: string[];
  /** Vazio quando não há exceções. */
  excecoes: string;
}

/** Só leitura: as regras são editadas na seção "Elegibilidade". */
@Component({
  selector: 'app-beneficios-visao-geral',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './beneficios-visao-geral.component.html',
  styleUrl: './beneficios-visao-geral.component.scss',
})
export class BeneficiosVisaoGeralComponent implements OnInit {
  private readonly beneficiosService = inject(BeneficiosService);
  private readonly loaderService = inject(LoaderService);
  private readonly toastService = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly injector = inject(Injector);

  readonly planoId = input.required<number>();
  readonly nomePlano = input('');

  /** A tela pai abre a Elegibilidade no benefício. */
  readonly editar = output<number>();

  private readonly elegibilidade = signal<ElegibilidadeBeneficios | null>(null);
  readonly carregando = signal(true);

  readonly matriz = computed<LinhaMatriz[]>(() => {
    const elegibilidade = this.elegibilidade();
    if (!elegibilidade) {
      return [];
    }
    const { beneficios } = elegibilidade;
    const nomes = new Map(beneficios.map((item) => [item.id, item.nome]));
    return beneficios.map((beneficio) => ({
      id: beneficio.id,
      nome: beneficio.nome,
      ativo: beneficio.ativo,
      condicoes: descreverRegras(beneficio.regras, nomes, elegibilidade),
      excecoes: beneficio.excecoes.trim(),
    }));
  });

  readonly totalAtivos = computed(() => this.matriz().filter((linha) => linha.ativo).length);

  ngOnInit(): void {
    this.loaderService.showLoader();
    this.beneficiosService
      .obterElegibilidade(this.planoId())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (elegibilidade) => {
          this.elegibilidade.set(elegibilidade);
          this.carregando.set(false);
          afterNextRender(() => this.loaderService.hideLoader(), { injector: this.injector });
        },
        error: () => {
          this.carregando.set(false);
          this.loaderService.hideLoader();
          this.toastService.show('Não foi possível carregar as regras dos benefícios.', 'error');
        },
      });
  }
}
